export class BasePrinterExecutor {
  constructor({ type = 'base', environment = 'web' } = {}) {
    this.type = type;
    this.environment = environment;
  }

  getCapabilities() {
    return {
      canDiscover: false,
      canPair: false,
      canPrint: false,
      transports: [],
      persistentConnection: false,
      notes: [],
    };
  }

  async discoverDevices() {
    return {
      success: false,
      devices: [],
      message: 'Discovery not supported for this executor.',
    };
  }

  async connect(_deviceDescriptor, _options = {}) {
    return {
      success: false,
      message: 'Connect not supported for this executor.',
    };
  }

  async disconnect() {
    return {
      success: false,
      message: 'Disconnect not supported for this executor.',
    };
  }

  async print(_data, _options = {}) {
    return {
      success: false,
      message: 'Print not supported for this executor.',
    };
  }

  async test(_options = {}) {
    return {
      success: false,
      message: 'Test print not supported for this executor.',
    };
  }

  async getStatus() {
    return {
      connected: false,
      message: 'Status not available.',
    };
  }

  async restoreConnection(_persistedState = {}) {
    return {
      success: false,
      connected: false,
      message: 'Restore connection not supported.',
    };
  }
}




